export default __webpack_public_path__ + "static/who-are-our-partners-c86beca4182cc9d6569a0e52c379c68c.png";